import CannedFishProduct from 'models/CannedFishProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import CannedFishPackage from './CannedFishPackage'

const productOptions = {
  packagingInfo: <CannedFishPackage />,
  productTitle: 'Canned Fish',
  model: CannedFishProduct,
  validCategories: ['08'],
  validSubCategories: ['001', '002', '003', '004'],
}

const CannedFish = () => <ProductForm product={productOptions} />

export default CannedFish

export const getCannedFishPackage = newProduct => {
  const newCannedFishPackage = {
    UPC: newProduct.UPC,
    FishType: newProduct.FishType,
    PackedIn: newProduct.PackedIn,
    Size: newProduct.Size,
  }
  return newCannedFishPackage
}

export const updateCannedFishPackage = newProduct => {
  const newCannedFishPackage = {
    UPC: newProduct.UPC,
    FishType: newProduct.FishType,
    PackedIn: newProduct.PackedIn,
    Size: newProduct.Size,
  }
  return newCannedFishPackage
}
